export default __webpack_public_path__ + "static/media/RVHUrgentCareCentre(UCC)v5220805RVHUCCv5_Page_7.c308b4d0.jpg";